/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class BrandProtectionIcon extends BaseIcon {
    getChildren = () => [
        <path
            d="M20.68,8h0a43.08,43.08,0,0,1-5.17-1.87h0a1.86,1.86,0,0,0-2.43,1,1.83,1.83,0,0,0-.15.73,1,1,0,0,0,0,.17,2.73,2.73,0,0,0-1.87,0,1,1,0,0,0,0-.17A1.83,1.83,0,0,0,9.24,6a1.9,1.9,0,0,0-.63.11h0l-5.56,2h0A4.56,4.56,0,0,0,.28,14,4.62,4.62,0,0,0,9,14H9L9.66,12a2.77,2.77,0,0,0,3.81.87,2.82,2.82,0,0,0,.93-1c.19.58.38,1.16.56,1.74h0A4.61,4.61,0,1,0,20.68,8ZM7.12,14.12a3,3,0,1,1,0-4.24h0A3,3,0,0,1,7.12,14.12ZM12,11.56a1,1,0,1,1,1-1h0A1,1,0,0,1,12,11.56Zm9.12,2.56a3,3,0,0,1-4.24,0,3,3,0,0,1,0-4.22,3,3,0,0,1,4.24,0h0A3,3,0,0,1,21.12,14.12Z"
            fill={this.getColor() === 'currentColor' ? '#aab4c4' : this.getColor()
        }/>]
    getViewBox = () => '0 0 24 24'
}
